// extracted by mini-css-extract-plugin
module.exports = {"boxShadow":"style_boxShadow__Dc6x9","secondSectionClassName":"style_secondSectionClassName___6VAf"};